<template>
  <b-container fluid id="contact" class="section">
    <div class="title">
      <h2>Contact Us</h2>
    </div>
    <b-row>
      <b-col md="6" sm="12">
        <h5>Phone</h5>
        <p>{{phone}}</p>
        <h5>Email</h5>
        <p>{{email}}</p>
      </b-col>
      <b-col md="6" sm="12">
        <h5>Address</h5>
        <p v-html="address">
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Contact",
  props: ["phone", "email", "address"]
};
</script>

<style lang="scss">
#contact {
  h5 {
    color: $secondary-color;
    text-transform: uppercase;
    &:not(:first-child) {
      margin-top: 2em;
    }
  }
  @include media-breakpoint-down(sm) {
    .row > :last-child {
      padding-top: 1.5em;
      justify-content: center !important;
    }
  }
}
</style>